import {
  resolveDetailComponent,
  resolveInputComponent,
} from "@data-root/react";
import { SchemaItem } from "@data-root/types";
import { List } from "antd";

export const changeThemeColor = (color: string) => {
  const metaThemeColor = document.querySelector("meta[name=theme-color]");
  if (metaThemeColor) metaThemeColor.setAttribute("content", color);
};

export const findAndAssert = <T,>(
  iterable: T[],
  predicate: (t: T, i: number) => boolean,
  message = "Element not found."
) => {
  const maybeT = iterable.find(predicate);
  if (!maybeT) throw new Error(message);
  return maybeT;
};

export const resolveWrappedFormTabComponent = (items: SchemaItem[]) => {
  return () => (
    <List
      split={false}
      dataSource={items}
      renderItem={(item, index) => (
        <List.Item>{renderInputComponent({ item, index })}</List.Item>
      )}
    />
  );
};

export const resolveWrappedDetailTabComponent = (items: SchemaItem[]) => {
  return () => (
    <List
      split={false}
      dataSource={items}
      renderItem={(item, index) => (
        <List.Item>{renderDetailComponent({ item, index })}</List.Item>
      )}
    />
  );
};

export const renderInputComponent = ({
  item,
}: {
  item: SchemaItem;
  index: number;
}) => {
  const props = {
    item,
  };
  const Component = resolveInputComponent(item.type);
  if (!Component) return null;
  return <Component key={`input_${item.id}`} {...props} />;
};

export const renderDetailComponent = ({
  item,
}: {
  item: SchemaItem;
  index: number;
}) => {
  const props = {
    item,
  };
  const Component = resolveDetailComponent(item.type);
  if (!Component) return null;
  return <Component key={`detail_${item.id}`} {...props} />;
};
